import React, { Component } from 'react';
import NavigationBar from 'components/shared/navigation/NavigationBar';
import ContractorsInvoicesTable from 'components/admin/contractors-invoices/ContractorsInvoicesTable';
import ContractorsWorkOrdersWithoutInvoices from 'components/admin/contractors-invoices/ContractorsWorkOrdersWithoutInvoices';
import {
  changeSearchText,
  initSearchFilters,
} from 'components/admin/contractors-invoices/store/actions';
import { changeInvoicesTab } from 'actions/admin/work-orders/work-orders';
import { connect } from 'react-redux';

class ContractorsInvoicesTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: 1,
    };
  }

  handleTabChange = (value) => {
    // Clear search text input
    this.props.onSearchTextChange('');
    this.props.onInitSearchFilters();
    this.setState({ currentTab: value });
    this.props.onInvoicesTabChange(value);
  };

  render() {
    return (
      <div className="contractors-invoices-table">
        <NavigationBar
          items={[
            {
              id: 1,
              title: 'Uploaded',
            },
            {
              id: 2,
              title: 'Not Uploaded',
            },
          ]}
          onSelected={this.handleTabChange}
        />

        {this.state.currentTab === 1 && <ContractorsInvoicesTable />}
        {this.state.currentTab === 2 && (
          <ContractorsWorkOrdersWithoutInvoices />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  onSearchTextChange: (text) => {
    dispatch(changeSearchText(text));
  },
  onInitSearchFilters: () => {
    dispatch(initSearchFilters());
  },
  onInvoicesTabChange: (newTab) => {
    dispatch(changeInvoicesTab(newTab));
  },
});

export default connect(null, mapDispatchToProps)(ContractorsInvoicesTabs);



// WEBPACK FOOTER //
// ./src/components/admin/contractors-invoices/ContractorsInvoicesTabs.js